import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import React from 'react';
import { colorsConservationSteps } from 'sequenceAnalyser/components/Colors/ColorsConservation/ColorsConservation';
import type { SelectedColorScheme } from 'sequenceAnalyser/utilities/colors';
import { ColorSchemesName, conservationColorBgStyle } from 'sequenceAnalyser/utilities/colors';

interface ComponentProps {
  colors: SelectedColorScheme;
}

function ColorItem({ label, bgStyle }: { label: string, bgStyle?: string }) {
  return (
    <Box
      display="inline-block"
      width="90px"
      mb={1}
    >
      <Box
        display="inline-block"
        mr={1}
        mt={-0.5}
        width="20px"
        height="16px"
        style={{
          background: bgStyle,
          border: '1px solid black',
          verticalAlign: 'middle',
        }}
      />
      {label}
    </Box>
  );
}

function PrintViewColors({ colors }: ComponentProps) {
  return (
    <Box p={2}>
      {colors.name === ColorSchemesName.Conservation && (
        <>
          {colorsConservationSteps.map((step) => (
            <ColorItem
              key={`color-item-${step.value}`}
              bgStyle={conservationColorBgStyle(step.value)}
              label={step.rangeLabel}
            />
          ))}
        </>
      )}

      {colors.name !== ColorSchemesName.Conservation && (
        <>
          {Object.keys(colors.infos).map((residue) => {
            const info = colors.infos[residue];

            return (
              <ColorItem
                key={`color-item-${residue}`}
                bgStyle={info.color ? `rgb(${info.color.join(',')})` : undefined}
                label={residue}
              />
            );
          })}
        </>
      )}
      <Typography>{`Color Scheme Legend (${colors.name})`}</Typography>
    </Box>
  );
}

export default PrintViewColors;
